/**
 * Christmas decorations: the rules, pure and testable.
 *
 * Decorations (Parol style) and snow sit ON TOP of whatever theme a person uses.
 * There is no sixth theme. This module only decides WHEN they show; the
 * drawing lives in src/features/christmas/.
 *
 * Season: Oct 1 to Jan 6, by the Philippine calendar (UTC+8, no daylight
 * saving), whatever time zone the browser is in.
 *
 * The two switches are per device, like the theme and text size beside them
 * (theme.ts, uiScale.ts): localStorage, no database column. Default is on.
 */

export const XMAS_DECOR_KEY = 'tap-xmas-decor';
export const XMAS_SNOW_KEY = 'tap-xmas-snow';

const MANILA_OFFSET_MS = 8 * 60 * 60 * 1000;

/** Oct 1 through Jan 6 inclusive, read on the Philippine calendar. */
export function inChristmasSeason(now: Date): boolean {
  const manila = new Date(now.getTime() + MANILA_OFFSET_MS);
  const month = manila.getUTCMonth();
  if (month >= 9) return true;
  return month === 0 && manila.getUTCDate() <= 6;
}

/** On unless the person explicitly turned it off. */
export function prefIsOn(stored: string | null): boolean {
  return stored !== 'off';
}

export function christmasOn(inSeason: boolean, decorPref: string | null): boolean {
  return inSeason && prefIsOn(decorPref);
}

/** Snow also needs decorations' season, its own switch, and no reduced-motion setting. */
export function snowOn(
  inSeason: boolean,
  snowPref: string | null,
  reducedMotion: boolean,
): boolean {
  return inSeason && prefIsOn(snowPref) && !reducedMotion;
}

/** Capped: about one flake per 17px of width, never more than 75. */
export function flakeCount(width: number): number {
  return Math.round(Math.min(75, width / 17));
}

/** The snow is drawn at most 30 times a second; a screen that calls faster is skipped. */
export const SNOW_FRAME_MS = 30;

/** Whether enough time has passed since the last drawn frame (null: none yet). */
export function snowFrameDue(now: number, last: number | null): boolean {
  return last === null || now - last >= SNOW_FRAME_MS;
}
